import React from 'react';
import { getUndiscountedBOGOTicketPrice } from '../../../utils/bogoTickets';
import { TicketContentProps } from '../TicketContent';
import type { TicketPriceProps } from '../TicketPrice';
import TicketPrice from '../TicketPrice';

export interface TicketDisplayCardContentFullSizePriceProps
    extends Pick<
            TicketPriceProps,
            'feesAndTaxes' | 'price' | 'priceWithoutDiscounts'
        >,
        Pick<TicketContentProps, 'cost' | 'currencyFormat'> {
    isAppRebrandActive?: boolean;
    isBOGO: boolean;
    isDisabled: boolean;
}

export const TicketDisplayCardContentFullSizePrice = ({
    cost,
    currencyFormat,
    feesAndTaxes,
    isAppRebrandActive = false,
    isBOGO,
    isDisabled,
    price,
    priceWithoutDiscounts,
}: TicketDisplayCardContentFullSizePriceProps) => {
    const originalPrice =
        isBOGO && cost && !priceWithoutDiscounts
            ? getUndiscountedBOGOTicketPrice({
                  currency: cost.currency,
                  value: cost.value,
                  currencyFormat,
              })
            : priceWithoutDiscounts;

    return (
        <TicketPrice
            disabled={isDisabled}
            feesAndTaxes={feesAndTaxes}
            isAppRebrandActive={isAppRebrandActive}
            price={price}
            priceWithoutDiscounts={originalPrice}
        />
    );
};
